import data from './attrs/data'
import methods from './attrs/methods'
import mounted from './attrs/mounted'
import watch from './attrs/watch'

export default {
  name: 'RedirectForm',
  data,
  methods,
  mounted,
  watch,
}
